import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        gridIsShow: true,
        formIsShow: false,

        eKatalogusTableAdditionalConfig: {
            initOnRender: false
        },
        eKatalogusActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        eKatalogusFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }
        ],
        eKatalogusSelectRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'selectRow'
            }
        ],
        eKatalogusRowActions: [
            {
                btn_text: '<i class="fas fa-trash-alt"></i>',
                title: 'Bejegyzés törlése',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteConfirm'
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Módosítás',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'showEKatForm'
            },
            /*{
                btn_text: '<i class="far fa-file-alt"></i>',
                title: 'Eseményhez feltöltött dokumentumok',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                event_payload: 'showEHRDocuments'
            },*/
        ],
        eKatalogusTableSearchFields: [
            {
                name: "paciensIdType",
                label: "Páciens azonosítás típus",
                formSize: 4,
                formType: "select",
                formVisible:true,
                selectOptions: {
                    apiCallback: Api.getIdTypeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "paciensId",
                label: "Páciens azonosító",
                formSize: 4,
                formVisible:true,
                formType: "text"
            },
            {
                name: "fromDate",
                label: "Időszak kezdete",
                formSize: 4,
                formVisible:true,
                formType: 'date',
            },
            {
                name: "toDate",
                label: "Időszak vége",
                formSize: 4,
                formVisible:true,
                formType: 'date',
            },
            {
                name: "surgos",
                label: "Sürgősségi adatlekérés",
                description: "Sürgős lekérdezés esetén indoklás szükséges!",
                formSize: 4,
                formVisible:true,
                formType: 'checkbox'
            },
            {
                label: "Sürgősségi adatlekérés oka",
                name: "surgosOk",
                formSize: 4,
                formVisible:true,
                formType: 'text'
            }
        ],
        eKatalogusOutpatientTableHeaderFields: [
            {
                name: "taj",
                label: "TAJ",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "betegIdTipus",
                label: "Páciens azonosítás típus",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getIdTypeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true
            },
            {
                name: "betegIdErtek",
                label: "Páciens azonosító",
                visibility: false,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "esemenyTipus",
                label: "Esemény típus",
                visibility: true,
                slot_name: "esemenyTipus_format",
                formType: "select",
                formSize: 6,
                formVisible: true,
                formRequired: true,
                formReadOnly: false,
                selectOptions: {
                    apiCallback: Api.getEsemenyTipusAllList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "ellatasId",
                label: "Ellátás ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "szakmakod",
                label: "Szakmakód",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getSzakmaKodList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: false
            },
            {
                name: "ellatasKezdete",
                label: "Ellátás kezdete",
                visibility: true,
                formType: "dateTime",
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            {
                name: "ellatasVege",
                label: "Ellátás vége",
                visibility: true,
                formRequired: true,
                formType: "dateTime",
                formSize: 6,
                formVisible: true
            },
            {
                name: "ellatoOrvos",
                label: "Ellátó orvos",
                visibility: false,
                formRequired: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctorForEeszt,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true,
                formReadOnly: true,
            },
            {
                name: "ellatoOsztaly",
                label: "Ellátó osztály",
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAllOrganizationUnitsForSelect,
                    formatText: function (val) {
                        return val.organizationUnitName;
                    },
                    formatOption: function (val) {
                        return val.organizationUnitName + " (" + val.organizationUnitId + ")";
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'organizationUnitName',
                    returnValue: 'organizationUnitId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true,
                //formReadOnly: true,
            },
            {
                name: "fekvobetegFelvetelTipusa",
                label: "Fekvőbeteg felvétel típusa",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "fekvobetegFelvetelJellege",
                label: "Fekvőbeteg felvétel jellege",
                visibility: false,
                formVisible: false
            },
            {
                name: "ambulansEllatasTipusa",
                label: "Ambuláns ellátás típusa",
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAmbulansEllatasList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true
            },
            {
                name: "beutaloOsztaly",
                label: "Beutaló osztály",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "beutaloOrvos",
                label: "Beutaló orvos",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "beutaloEsetAzonosito",
                label: "Beutaló eset ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "eBeutaloId",
                label: "E-beuatló ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ambulansTovabbkuldes",
                label: "Ambuláns továbbküldés",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensTovabbiSorsa",
                label: "Páciens további sorsa",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getPaciensTovabbiSorsaList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: false
            },
            {
                name: "torzsszam",
                label: "Törzsszám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "apolasiSorszam",
                label: "Ápolási sorszám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ambulansNaploszam",
                label: "Ambuláns naplószám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "iranydiagnozis",
                label: "Irány diagnózis",
                visibility: false,
                formType: "selectBNOSingle",
                selectOptions: {
                    formatText: function (val) {
                        return val.leiras;
                    }
                },
                formSize: 6,
                formVisible: true
            },
            {
                name: "apolastIndolkoFodiagnozis",
                label: "Ápolást indokló fődiagnózis",
                visibility: false,
                formType: "selectBNOSingle",
                selectOptions: {
                    formatText: function (val) {
                        return val.leiras;
                    }
                },
                formSize: 6,
                formVisible: true
            },
            {
                name: "ujszulottTesttomege",
                label: "Újszülött testtömege",
                visibility: false,
                formType: "number",
                formVisible: false
            },
            {
                name: "kiseretOka",
                label: "Kíséret oka",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensIranyitoszama",
                label: "Páciens irányítószáma",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensEletkora",
                label: "Páciens életkora",
                visibility: false,
                formType: "number",
                formVisible: false
            },
            {
                name: "ehrDokumentumTipus",
                label: "EHR dokumentum típus",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ehrId",
                label: "EHR ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "hivatkozottEKATId",
                label: "Hivatkozott E-katalógus ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mutetiFoBeavatkozas",
                label: "Műtéti fő beavatkozás",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "eReceptId",
                label: "Recept ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "gyogyszerATCKod",
                label: "Gyógyszer ATC kód",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "gyogyszerTTTKod",
                label: "Gyógyszer TTT kód",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "felirtGyogyszermennyisegIdotartama",
                label: "Felírt gyógyszermennyiség időtartama",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "jogcim",
                label: "Jogcím",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesiAdatlapSorszama",
                label: "mentesiAdatlapSorszama",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentofeladatTipusa",
                label: "mentofeladatTipusa",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtadoIntezmenye",
                label: "mentesAtadoIntezmenye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtvevoIntezmenye",
                label: "mentesAtvevoIntezmenye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesFelvetelHelye",
                label: "mentesFelvetelHelye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtadasHelye",
                label: "mentesAtadasHelye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mimeType",
                label: "mimeType",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "status",
                label: "Státusz",
                visibility: true,
                slot_name: "esemenyStatus_format",
                formType: "text",
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        eKatalogusFeuTableHeaderFields: [
            {
                name: "taj",
                label: "TAJ",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "betegIdTipus",
                label: "Páciens azonosítás típus",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getIdTypeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true
            },
            {
                name: "betegIdErtek",
                label: "Páciens azonosító",
                visibility: false,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "esemenyTipus",
                label: "Esemény típus",
                visibility: true,
                slot_name: "esemenyTipus_format",
                formType: "select",
                formSize: 6,
                formVisible: true,
                formRequired: true,
                formReadOnly: false,
                selectOptions: {
                    apiCallback: Api.getEsemenyTipusFeuList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "ellatasId",
                label: "Ellátás ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "szakmakod",
                label: "Szakmakód",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getSzakmaKodList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: false
            },
            {
                name: "ellatasKezdete",
                label: "Ellátás kezdete",
                visibility: true,
                formType: "dateTime",
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            {
                name: "ellatasVege",
                label: "Ellátás vége",
                visibility: true,
                formRequired: true,
                formType: "dateTime",
                formSize: 6,
                formVisible: true
            },
            {
                name: "ellatoOrvos",
                label: "Ellátó orvos",
                visibility: false,
                formRequired: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctorForEeszt,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true,
                formReadOnly: true,
            },
            {
                name: "ellatoOsztaly",
                label: "Ellátó osztály",
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAllOrganizationUnitsForSelect,
                    formatText: function (val) {
                        return val.organizationUnitName;
                    },
                    formatOption: function (val) {
                        return val.organizationUnitName + " (" + val.organizationUnitId + ")";
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'organizationUnitName',
                    returnValue: 'organizationUnitId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true,
                //formReadOnly: true,
            },
            {
                name: "fekvobetegFelvetelTipusa",
                label: "Fekvőbeteg felvétel típusa",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "fekvobetegFelvetelJellege",
                label: "Fekvőbeteg felvétel jellege",
                visibility: false,
                formVisible: false
            },
            {
                name: "ambulansEllatasTipusa",
                label: "Ambuláns ellátás típusa",
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAmbulansEllatasList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: false
            },
            {
                name: "beutaloOsztaly",
                label: "Beutaló osztály",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "beutaloOrvos",
                label: "Beutaló orvos",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "beutaloEsetAzonosito",
                label: "Beutaló eset ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "eBeutaloId",
                label: "E-beuatló ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "iranydiagnozis",
                label: "Irány diagnózis",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ambulansTovabbkuldes",
                label: "Ambuláns továbbküldés",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensTovabbiSorsa",
                label: "Páciens további sorsa",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getPaciensTovabbiSorsaList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: false
            },
            {
                name: "torzsszam",
                label: "Törzsszám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "apolasiSorszam",
                label: "Ápolási sorszám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ambulansNaploszam",
                label: "Ambuláns naplószám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "apolastIndolkoFodiagnozis",
                label: "Ápolást indokló fődiagnózis",
                visibility: false,
                formType: "selectBNOSingle",
                selectOptions: {
                    formatText: function (val) {
                        return val.leiras;
                    }
                },
                formSize: 6,
                formVisible: false
            },
            {
                name: "ujszulottTesttomege",
                label: "Újszülött testtömege",
                visibility: false,
                formType: "number",
                formVisible: false
            },
            {
                name: "kiseretOka",
                label: "Kíséret oka",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensIranyitoszama",
                label: "Páciens irányítószáma",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensEletkora",
                label: "Páciens életkora",
                visibility: false,
                formType: "number",
                formVisible: false
            },
            {
                name: "ehrDokumentumTipus",
                label: "EHR dokumentum típus",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ehrId",
                label: "EHR ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "hivatkozottEKATId",
                label: "Hivatkozott E-katalógus ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mutetiFoBeavatkozas",
                label: "Műtéti fő beavatkozás",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "eReceptId",
                label: "Recept ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "gyogyszerATCKod",
                label: "Gyógyszer ATC kód",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "gyogyszerTTTKod",
                label: "Gyógyszer TTT kód",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "felirtGyogyszermennyisegIdotartama",
                label: "Felírt gyógyszermennyiség időtartama",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "jogcim",
                label: "Jogcím",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesiAdatlapSorszama",
                label: "mentesiAdatlapSorszama",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentofeladatTipusa",
                label: "mentofeladatTipusa",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtadoIntezmenye",
                label: "mentesAtadoIntezmenye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtvevoIntezmenye",
                label: "mentesAtvevoIntezmenye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesFelvetelHelye",
                label: "mentesFelvetelHelye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtadasHelye",
                label: "mentesAtadasHelye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mimeType",
                label: "mimeType",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "status",
                label: "Státusz",
                visibility: true,
                slot_name: "esemenyStatus_format",
                formType: "text",
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        eKatalogusEgynaposSebeszetFields: [
            {
                name: "taj",
                label: "TAJ",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "betegIdTipus",
                label: "Páciens azonosítás típus",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getIdTypeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "betegIdErtek",
                label: "Páciens azonosító",
                visibility: false,
                formType: "text",
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "esemenyTipus",
                label: "Esemény típus",
                visibility: true,
                slot_name: "esemenyTipus_format",
                formType: "select",
                formSize: 4,
                formVisible: true,
                formRequired: true,
                formReadOnly: false,
                selectOptions: {
                    apiCallback: Api.getEsemenyTipusAllList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "ellatasId",
                label: "Ellátás ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "szakmakod",
                label: "Szakmakód",
                visibility: false,
                formType: "select",
                formSize: 4,
                formVisible: true,
                formRequired: true,
                selectOptions: {
                    apiCallback: Api.getSzakmaKodList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "ellatasKezdete",
                label: "Ellátás kezdete",
                visibility: true,
                formType: "dateTime",
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "ellatasVege",
                label: "Ellátás vége",
                visibility: true,
                formRequired: true,
                formType: "dateTime",
                formSize: 4,
                formVisible: true
            },
            {
                name: "ellatoOrvos",
                label: "Ellátó orvos",
                visibility: false,
                formRequired: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctorForEeszt,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formVisible: true,
                formReadOnly: true,
            },
            {
                name: "ellatoOsztaly",
                label: "Ellátó osztály",
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAllOrganizationUnitsForSelect,
                    formatText: function (val) {
                        return val.organizationUnitName;
                    },
                    formatOption: function (val) {
                        return val.organizationUnitName + " (" + val.organizationUnitId + ")";
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'organizationUnitName',
                    returnValue: 'organizationUnitId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formVisible: true,
                //formReadOnly: true,
            },
            {
                name: "fekvobetegFelvetelTipusa",
                label: "Fekvőbeteg felvétel típusa",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 4,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getFekvobetegFelvitelTipusaList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "fekvobetegFelvetelJellege",
                label: "Fekvőbeteg felvétel jellege",
                formVisible: true,
                formRequired: true,
                formSize: 4,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getFekvobetegJellegeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "ambulansEllatasTipusa",
                label: "Ambuláns ellátás típusa",
                visibility: false,
                formRequired: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAmbulansEllatasList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formVisible: true
            },
            {
                name: "beutaloOsztaly",
                label: "Beutaló osztály",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "beutaloOrvos",
                label: "Beutaló orvos",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "beutaloEsetAzonosito",
                label: "Beutaló eset ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "eBeutaloId",
                label: "E-beuatló ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ambulansTovabbkuldes",
                label: "Ambuláns továbbküldés",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensTovabbiSorsa",
                label: "Páciens további sorsa",
                visibility: false,
                formSize: 4,
                formVisible: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getPaciensTovabbiSorsaList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "torzsszam",
                label: "Törzsszám",
                visibility: false,
                formType: "text",
                formVisible: true,
                formSize: 4
            },
            {
                name: "apolasiSorszam",
                label: "Ápolási sorszám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ambulansNaploszam",
                label: "Ambuláns naplószám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "iranydiagnozis",
                label: "Irány diagnózis",
                visibility: false,
                formType: "selectBNOSingle",
                selectOptions: {
                    formatText: function (val) {
                        return val.leiras;
                    }
                },
                formSize: 4,
                formVisible: true
            },
            {
                name: "apolastIndolkoFodiagnozis",
                label: "Ápolást indokló fődiagnózis",
                visibility: false,
                formType: "selectBNOSingle",
                selectOptions: {
                    formatText: function (val) {
                        return val.leiras;
                    }
                },
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "ujszulottTesttomege",
                label: "Újszülött testtömege",
                visibility: false,
                formType: "number",
                formVisible: false
            },
            {
                name: "kiseretOka",
                label: "Kíséret oka",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensIranyitoszama",
                label: "Páciens irányítószáma",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensEletkora",
                label: "Páciens életkora",
                visibility: false,
                formType: "number",
                formVisible: false
            },
            {
                name: "ehrDokumentumTipus",
                label: "EHR dokumentum típus",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ehrId",
                label: "EHR ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "hivatkozottEKATId",
                label: "Hivatkozott E-katalógus ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mutetiFoBeavatkozas",
                label: "Műtéti fő beavatkozás",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "eReceptId",
                label: "Recept ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "gyogyszerATCKod",
                label: "Gyógyszer ATC kód",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "gyogyszerTTTKod",
                label: "Gyógyszer TTT kód",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "felirtGyogyszermennyisegIdotartama",
                label: "Felírt gyógyszermennyiség időtartama",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "jogcim",
                label: "Jogcím",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesiAdatlapSorszama",
                label: "mentesiAdatlapSorszama",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentofeladatTipusa",
                label: "mentofeladatTipusa",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtadoIntezmenye",
                label: "mentesAtadoIntezmenye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtvevoIntezmenye",
                label: "mentesAtvevoIntezmenye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesFelvetelHelye",
                label: "mentesFelvetelHelye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtadasHelye",
                label: "mentesAtadasHelye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mimeType",
                label: "mimeType",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "status",
                label: "Státusz",
                visibility: true,
                slot_name: "esemenyStatus_format",
                formType: "text",
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        covidRapidAntigenTestFields: [
            {
                name: "taj",
                label: "TAJ",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "betegIdTipus",
                label: "Páciens azonosítás típus",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getIdTypeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formVisible: true
            },
            {
                name: "betegIdErtek",
                label: "Páciens azonosító",
                visibility: false,
                formType: "text",
                formSize: 2,
                formVisible: true
            },
            {
                name: "esemenyTipus",
                label: "Esemény típus",
                visibility: true,
                slot_name: "esemenyTipus_format",
                formType: "select",
                formSize: 2,
                formVisible: true,
                formRequired: true,
                formReadOnly: true,
                selectOptions: {
                    apiCallback: Api.getEsemenyTipusCovidRATList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "ellatasId",
                label: "Ellátás ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "szakmakod",
                label: "Szakmakód",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getSzakmaKodList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: false
            },
            {
                name: "ellatasKezdete",
                label: "Ellátás kezdete",
                visibility: true,
                formType: "dateTime",
                formSize: 2,
                formVisible: true,
                formRequired: true
            },
            {
                name: "ellatasVege",
                label: "Ellátás vége",
                visibility: true,
                formRequired: true,
                formType: "dateTime",
                formSize: 6,
                formVisible: false
            },
            {
                name: "ellatoOrvos",
                label: "Ellátó orvos",
                visibility: false,
                formRequired: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctorForEeszt,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formVisible: true,
                formReadOnly: true,
            },
            {
                name: "ellatoOsztaly",
                label: "Ellátó osztály",
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAllOrganizationUnitsForSelect,
                    formatText: function (val) {
                        return val.organizationUnitName;
                    },
                    formatOption: function (val) {
                        return val.organizationUnitName + " (" + val.organizationUnitId + ")";
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'organizationUnitName',
                    returnValue: 'organizationUnitId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formVisible: true,
                //formReadOnly: true,
            },
            {
                name: "fekvobetegFelvetelTipusa",
                label: "Fekvőbeteg felvétel típusa",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "fekvobetegFelvetelJellege",
                label: "Fekvőbeteg felvétel jellege",
                visibility: false,
                formVisible: false
            },
            {
                name: "ambulansEllatasTipusa",
                label: "Ambuláns ellátás típusa",
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAmbulansEllatasList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: false
            },
            {
                name: "beutaloOsztaly",
                label: "Beutaló osztály",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "beutaloOrvos",
                label: "Beutaló orvos",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "beutaloEsetAzonosito",
                label: "Beutaló eset ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "eBeutaloId",
                label: "E-beuatló ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ambulansTovabbkuldes",
                label: "Ambuláns továbbküldés",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensTovabbiSorsa",
                label: "Páciens további sorsa",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getPaciensTovabbiSorsaList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: false
            },
            {
                name: "torzsszam",
                label: "Törzsszám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "apolasiSorszam",
                label: "Ápolási sorszám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ambulansNaploszam",
                label: "Ambuláns naplószám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "iranydiagnozis",
                label: "Irány diagnózis",
                visibility: false,
                formType: "selectBNOSingle",
                selectOptions: {
                    formatText: function (val) {
                        return val.leiras;
                    }
                },
                formSize: 6,
                formVisible: false
            },
            {
                name: "apolastIndolkoFodiagnozis",
                label: "Ápolást indokló fődiagnózis",
                visibility: false,
                formType: "select",
                selectOptions: {
                    externalOptionList: [{id: 'U0710', text: 'Pozitív'}, {id: 'U9990', text: 'Negatív'}, {id: '-1', text: 'Nem értékelhető'}],
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formVisible: true,
                formRequired: true
            },
            {
                name: "ujszulottTesttomege",
                label: "Újszülött testtömege",
                visibility: false,
                formType: "number",
                formVisible: false
            },
            {
                name: "kiseretOka",
                label: "Kíséret oka",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensIranyitoszama",
                label: "Páciens irányítószáma",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensEletkora",
                label: "Páciens életkora",
                visibility: false,
                formType: "number",
                formVisible: false
            },
            {
                name: "ehrDokumentumTipus",
                label: "EHR dokumentum típus",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ehrId",
                label: "EHR ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "hivatkozottEKATId",
                label: "Hivatkozott E-katalógus ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mutetiFoBeavatkozas",
                label: "Műtéti fő beavatkozás",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "eReceptId",
                label: "Recept ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "gyogyszerATCKod",
                label: "Gyógyszer ATC kód",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "gyogyszerTTTKod",
                label: "Gyógyszer TTT kód",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "felirtGyogyszermennyisegIdotartama",
                label: "Felírt gyógyszermennyiség időtartama",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "jogcim",
                label: "Jogcím",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesiAdatlapSorszama",
                label: "mentesiAdatlapSorszama",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentofeladatTipusa",
                label: "mentofeladatTipusa",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtadoIntezmenye",
                label: "mentesAtadoIntezmenye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtvevoIntezmenye",
                label: "mentesAtvevoIntezmenye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesFelvetelHelye",
                label: "mentesFelvetelHelye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtadasHelye",
                label: "mentesAtadasHelye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mimeType",
                label: "mimeType",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "status",
                label: "Státusz",
                visibility: true,
                slot_name: "esemenyStatus_format",
                formType: "text",
                formVisible: false
            },
            {
                name: "caseType",
                label: "Ellátás típus",
                formVisible: true,
                formRequired: true,
                formSize: 2,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getEllatasList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "rowBreak",
                label: "rowBreak",
                rowBreak: true,
                formSize: 8,
                visibility: false,
                formVisible: true
            },
            {
                name: "tesztTipus",
                label: "Teszt típusa",
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getCovidRapidTestList,
                    formatText: function (val) {
                        return val.commercialName;
                    },
                    formatOption: function (val) {
                        return val.commercialName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'commercialName',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            /*{
                name: "ogyeiAzonosito",
                label: "OGYEI azonosító",
                formVisible: true,
                formSize: 3,
                formType: "text"
            },*/
            {
                name: "termekGyartasiSorozatAzonosito",
                label: "Termék gyártási sorozat azonosítója",
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "termekEgyediGyartasiAzonosito",
                label: "Termék egyedi gyártási azonosítója",
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "termekLejaratiDatum",
                label: "Termék lejárati dátuma",
                formVisible: true,
                formSize: 3,
                formType: "date"
            },
            {
                name: "mintaTipusa",
                label: "Minta típusa",
                formVisible: true,
                formRequired: false,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getMintavetelTipusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "mintavetelIdopontja",
                label: "Mintavétel időpontja",
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "dateTime"
            },
            {
                name: "eredmenyIdopontja",
                label: "Eredmény időpontja",
                formVisible: true,
                formRequired: false,
                formSize: 3,
                formType: "dateTime"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        covidRapidAntigenTestEkatalogusFields: [
            {
                name: "taj",
                label: "TAJ",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "betegIdTipus",
                label: "Páciens azonosítás típus",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getIdTypeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formVisible: true
            },
            {
                name: "betegIdErtek",
                label: "Páciens azonosító",
                visibility: false,
                formType: "text",
                formSize: 2,
                formVisible: true
            },
            {
                name: "esemenyTipus",
                label: "Esemény típus",
                visibility: true,
                slot_name: "esemenyTipus_format",
                formType: "select",
                formSize: 2,
                formVisible: true,
                formRequired: true,
                formReadOnly: true,
                selectOptions: {
                    apiCallback: Api.getEsemenyTipusCovidRATList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "ellatasId",
                label: "Ellátás ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "szakmakod",
                label: "Szakmakód",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getSzakmaKodList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: false
            },
            {
                name: "ellatasKezdete",
                label: "Ellátás kezdete",
                visibility: true,
                formType: "dateTime",
                formSize: 2,
                formVisible: true,
                formRequired: true
            },
            {
                name: "ellatasVege",
                label: "Ellátás vége",
                visibility: true,
                formRequired: true,
                formType: "dateTime",
                formSize: 6,
                formVisible: false
            },
            {
                name: "ellatoOrvos",
                label: "Ellátó orvos",
                visibility: false,
                formRequired: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctorForEeszt,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formVisible: true,
                formReadOnly: true,
            },
            {
                name: "ellatoOsztaly",
                label: "Ellátó osztály",
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAllOrganizationUnitsForSelect,
                    formatText: function (val) {
                        return val.organizationUnitName;
                    },
                    formatOption: function (val) {
                        return val.organizationUnitName + " (" + val.organizationUnitId + ")";
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'organizationUnitName',
                    returnValue: 'organizationUnitId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formVisible: true,
                //formReadOnly: true,
            },
            {
                name: "fekvobetegFelvetelTipusa",
                label: "Fekvőbeteg felvétel típusa",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "fekvobetegFelvetelJellege",
                label: "Fekvőbeteg felvétel jellege",
                visibility: false,
                formVisible: false
            },
            {
                name: "ambulansEllatasTipusa",
                label: "Ambuláns ellátás típusa",
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAmbulansEllatasList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: false
            },
            {
                name: "beutaloOsztaly",
                label: "Beutaló osztály",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "beutaloOrvos",
                label: "Beutaló orvos",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "beutaloEsetAzonosito",
                label: "Beutaló eset ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "eBeutaloId",
                label: "E-beuatló ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ambulansTovabbkuldes",
                label: "Ambuláns továbbküldés",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensTovabbiSorsa",
                label: "Páciens további sorsa",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getPaciensTovabbiSorsaList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: false
            },
            {
                name: "torzsszam",
                label: "Törzsszám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "apolasiSorszam",
                label: "Ápolási sorszám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ambulansNaploszam",
                label: "Ambuláns naplószám",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "iranydiagnozis",
                label: "Irány diagnózis",
                visibility: false,
                formType: "selectBNOSingle",
                selectOptions: {
                    formatText: function (val) {
                        return val.leiras;
                    }
                },
                formSize: 6,
                formVisible: false
            },
            {
                name: "apolastIndolkoFodiagnozis",
                label: "Ápolást indokló fődiagnózis",
                visibility: false,
                formType: "select",
                selectOptions: {
                    externalOptionList: [{id: 'U0710', text: 'Pozitív'}, {id: 'U9990', text: 'Negatív'}, {id: '-1', text: 'Nem értékelhető'}],
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formVisible: true,
                formRequired: true
            },
            {
                name: "ujszulottTesttomege",
                label: "Újszülött testtömege",
                visibility: false,
                formType: "number",
                formVisible: false
            },
            {
                name: "kiseretOka",
                label: "Kíséret oka",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensIranyitoszama",
                label: "Páciens irányítószáma",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "paciensEletkora",
                label: "Páciens életkora",
                visibility: false,
                formType: "number",
                formVisible: false
            },
            {
                name: "ehrDokumentumTipus",
                label: "EHR dokumentum típus",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "ehrId",
                label: "EHR ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "hivatkozottEKATId",
                label: "Hivatkozott E-katalógus ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mutetiFoBeavatkozas",
                label: "Műtéti fő beavatkozás",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "eReceptId",
                label: "Recept ID",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "gyogyszerATCKod",
                label: "Gyógyszer ATC kód",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "gyogyszerTTTKod",
                label: "Gyógyszer TTT kód",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "felirtGyogyszermennyisegIdotartama",
                label: "Felírt gyógyszermennyiség időtartama",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "jogcim",
                label: "Jogcím",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesiAdatlapSorszama",
                label: "mentesiAdatlapSorszama",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentofeladatTipusa",
                label: "mentofeladatTipusa",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtadoIntezmenye",
                label: "mentesAtadoIntezmenye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtvevoIntezmenye",
                label: "mentesAtvevoIntezmenye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesFelvetelHelye",
                label: "mentesFelvetelHelye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mentesAtadasHelye",
                label: "mentesAtadasHelye",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "mimeType",
                label: "mimeType",
                visibility: false,
                formType: "text",
                formVisible: false
            },
            {
                name: "status",
                label: "Státusz",
                visibility: true,
                slot_name: "esemenyStatus_format",
                formType: "text",
                formVisible: false
            }
        ],
    }
}
